var FIGURE = FIGURE || {};

FIGURE.mobileNav = function() {
    var dialog  = document.getElementById('mobile-nav');
    var openBtn = document.querySelector('[data-mobile-nav-open]');
    var closeBtn = document.querySelector('[data-mobile-nav-close]');

    if (!dialog || !openBtn) return;

    // Stamp a sequential index on every nav item for the staggered CSS animation
    dialog.querySelectorAll('li').forEach(function(li, i) {
        li.style.setProperty('--nav-index', i);
    });

    openBtn.addEventListener('click', function() {
        dialog.showModal();
        // showModal() focuses the close button, and Safari rings it: a tap never focuses the
        // open button there, so the move reads as keyboard focus. Take focus on the dialog instead.
        dialog.focus();
        openBtn.setAttribute('aria-expanded', 'true');
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            dialog.close();
        });
    }

    dialog.addEventListener('click', function(e) {
        // Backdrop click — target is the dialog element itself when clicking outside content
        if (e.target === dialog) {
            dialog.close();
            return;
        }

        // Any link in here has finished with the menu: a nav link is about to replace the
        // page, a .scrollto link jumps within it, and Sign Up / Sign In open a bootstrap
        // modal without navigating at all. That last case is why closing can't be left to
        // the page unload — showModal() puts this dialog in the top layer, where it paints
        // above the bootstrap modal whatever the z-index, leaving the menu sitting on top
        // of the sign-in form. Closing here doesn't swallow the click: bootstrap's trigger
        // is delegated on document, further along the same propagation path.
        if (e.target.closest('a[href]')) dialog.close();
    });

    // Sync aria-expanded on any close (ESC, backdrop, close button)
    dialog.addEventListener('close', function() {
        openBtn.setAttribute('aria-expanded', 'false');
    });
}();
